import { useSelector } from 'react-redux'
import { getLocation } from '@/logic/app/reducer'

export const useLocation = () => useSelector(getLocation())
